import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Alert, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "./Button";
import useDidMountEffect from "../utils/useDidMountEffect";
import AztecLibraryScript from "./AztecLibraryScript";
import $ from "jquery";
import {toast} from "react-toastify";
import Select from "../componentsReusable/Select";
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";
import classnames from "classnames";
import {isNil} from "lodash";
import QRCode from "react-qr-code";
import {isDesktop} from "react-device-detect";
import LoginQrCodeModal from "./LoginQrCodeModal";
import {useTranslation} from "react-i18next";
window.$ = $

let aztecDecoder
const AztecCameraModal = props => {
  const { t } = useTranslation('aztec_camera_modal')
  const videoContainerId = 'camera_container';
  const [alertDisplay, setAlertDisplay] = useState(false)
  const [devices, setDevices] = useState([])
  const [deviceId, setDeviceId] = useState(localStorage.cameraId ?? null)
  const [aztecScanned, setAztecScanned] = useState(null)

  useDidMountEffect(() => {
    let OS = getMobileOperatingSystem();
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    init()

    setTimeout(() => {
      aztecDecoder = new window.Neptis.RegistrationCertificateDecoder(
        videoContainerId,
        () => {
          //onVideoInitializedSuccessHandler
          init()
        },
        (message) => {
          if (OS == 'iOS') {
            if (!isSafari){
              toast.warning(t('msg_ios_warning'))
            }
          }
        },
        (aztec) => {
          setAztecScanned(aztec)
        },
      );
    }, 1)

    setTimeout(() => {
      setAlertDisplay(true)
    }, 12000)
  })

  useAfterUpdateEffect(() => {
    if(aztecDecoder?.videoStarted){
      aztecDecoder.stop()
    }
    props.onDecoded(aztecScanned)
  }, [aztecScanned])

  useAfterUpdateEffect(() => {
    if(devices.length === 1){
      setDeviceId(devices[0].value)
    }
  }, [devices])

  useAfterUpdateEffect(() => {
    localStorage.cameraId = deviceId
    setTimeout(() => {
      if(aztecDecoder?.videoStarted){
        aztecDecoder.stop()
        aztecDecoder.start()
      }
    }, 50)
  }, [deviceId])

  const closeModal = () => {
    if(aztecDecoder?.videoStarted){
      aztecDecoder.stop()
    }
    props.onClose()
  }

  const init = () => {
    if (!navigator.mediaDevices?.enumerateDevices) {
      toast.error(t('msg_error'))
      closeModal()
    } else {
      // if(OS == 'Android'){
      navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          devices = devices.filter(device => !!device.deviceId)
          devices.forEach((device) => {
            let deviceSide = device.label;
            if (device.kind === 'videoinput' && ( deviceSide.includes("back") || deviceSide.includes("Rück"))) {
              setDeviceId(deviceId => {
                if(isNil(deviceId)){
                  return device.deviceId
                }

                return deviceId
              })
            }
          });

          setDevices(devices
            .filter(device => device.kind === 'videoinput')
            .map(device => {
              return {
                label: device.label,
                value: device.deviceId
              }
            }))
        })
        .catch((err) => {
          // console.error(`${err.name}: ${err.message}`);
        });
      // }
    }
  }

  const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }
    return "unknown";
  }

  return <React.Fragment>
    <AztecLibraryScript />
    <Modal size={"lg"} isOpen toggle={() => closeModal()}>
      <ModalHeader toggle={() => closeModal()}>{t('modal.header')}</ModalHeader>
      <ModalBody>
        <input
          id="deviceId"
          className="d-none"
          value={deviceId}
        />
        {isDesktop && <Alert color={'info'}>
          <div className="d-flex flex-row flex-nowrap align-items-center">
            <span className="mr-2">{t('modal.body.mobile_login')}</span>
            <LoginQrCodeModal />
          </div>
        </Alert>}
        {devices.length > 1 && <div className="mb-2">
          {alertDisplay && <Alert className="mb-2" color={'warning'}>{t('modal.body.alert')}</Alert>}
          <div className="d-flex flex-row flex-nowrap align-items-center">
            <span className="text-nowrap mr-2">{t('modal.body.select_cam')}:</span>
            <Select
              isSearchable={false}
              onChange={setDeviceId}
              options={devices}
              value={deviceId}
            />
          </div>
        </div>}
        <div
          id={videoContainerId}
          className={classnames({
            'd-none': !deviceId
          })}
          style={{ width: '100%', height: '100vh', maxHeight: '65vh' }}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => closeModal()}>{t('common:btn.close')}</Button>
      </ModalFooter>
    </Modal>
  </React.Fragment>;
};

AztecCameraModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDecoded: PropTypes.func.isRequired,
};

export default AztecCameraModal;